import { DeeplinkConfig } from 'capability-ng-deeplink';
import { UserModesService } from '../user_modes/user_modes_service';
import { ApplicationConfiguration } from '../models/app_config_model';
import { ApplicationDetails } from '../models/app_config_model';
import * as _4 from 'lodash4';
import { IUtilityConstant } from '../../src/core/constants/utility_constants';

class StartupController {
  constructor(
    private applicationLoginConfiguration: any,
    private ngDeeplinkConfig: DeeplinkConfig,
    private $state: ng.ui.IStateService,
    private accountModel: any,
    private loginConfigModel: any,
    private ngUserModesService: UserModesService,
    private appConfigModel: ApplicationConfiguration,
    private utilityConstant: IUtilityConstant
  ) {}
  $onInit() {
    this.applicationLoginConfiguration.configure();
    const deepLinkState = this.ngDeeplinkConfig.getStoredState();
    const deepLinkHref = this.ngDeeplinkConfig.getStoredHref();
    const sgdRedirectUrl = localStorage.getItem(this.utilityConstant.REDIRECT_URL_KEY);
    const willRedirectHasAcceptedTerms = this.accountModel.acceptedTerms;
    // TODO: Auth Check should be in force_app_config_load.es
    if (!this.accountModel.isLoggedIn()) {
      this.ngUserModesService.forceAuthentication();
      return;
    }

    if (!willRedirectHasAcceptedTerms) {
      this.ngUserModesService.checkTOS();
      return;
    }

    if (this.accountModel.isLoggedIn() && !_4.isEmpty(deepLinkHref)) {
      this.ngUserModesService.userMode = `student`;
      location.assign(deepLinkHref);
      return;
    }
    if (this.accountModel.isLoggedIn() && !_4.isEmpty(deepLinkState)) {
      this.ngUserModesService.userMode = `student`;
      this.$state.go(deepLinkState.state, deepLinkState.stateParams);
      return;
    }
    if (sgdRedirectUrl) {
      location.assign(sgdRedirectUrl);
      localStorage.removeItem(this.utilityConstant.REDIRECT_URL_KEY);
      return;
    }

    this.ngUserModesService.checkTOS();
  }
}

export class StartupComponent implements angular.IComponentOptions {
  public templateUrl: string = 'lib/startup/startup.html';
  public controller = StartupController;
}



// WEBPACK FOOTER //
// ./app/lib/startup/startup.ts